// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"fc85b0c3","327":"058bf12d","348":"8977a700","563":"43241c64","580":"e7a2b074","977":"e781fb59","988":"45c35fcc"}[chunkId] + ".chunk.js";
};